module.exports = __webpack_public_path__ + "3f84762ded3f83780c66efa9e62a0d5b.mtl";